module.exports = __webpack_public_path__ + "img/chicken-steal.856037d9.gif";